<template>
    <div class="row">
        <div class="col-12 q-px-xs">
            <q-select
                v-model="typeOfAppointment"
                ref="typeOfAppointmentRef"
                outlined
                :options="typeOfAppointmentOpts"
                label="Type of Appointment"
                emit-value
                map-options
                :rules="[
                    (val) => (val && val.length > 0) || 'Please type something',
                ]"
            ></q-select>
        </div>
        <div class="col-12 q-px-xs q-mt-sm">
            <q-select
                v-model="prefferedClinic"
                ref="prefferedClinicRef"
                :options="prefferedClinicOpts"
                outlined
                label="Preferred Clinic"
                emit-value
                map-options
                :rules="[
                    (val) => (val && val.length > 0) || 'Please type something',
                ]"
            ></q-select>
        </div>
    </div>

    <div class="row q-pa-sm">
        <div class="col-12">
            <strong style="font-size: 1.5rem; text-transform: uppercase">
                Preferred time & date
            </strong>

            <p>
                We will try to accommodate as best as possible your preferre
                dates/times
            </p>

            <p>
                <strong>
                    * Please note: request cannot be within 1 bussiness day
                </strong>
            </p>
        </div>
    </div>

    <div class="row">
        <div class="col-8 q-px-xs">
            <q-input
                v-model="prefDate1"
                ref="prefDate1Ref"
                :rules="[
                    'date',
                    (val) => (val && val.length > 0) || 'Please type something',
                ]"
                mask="date"
                label="Preferred Date #1"
                outlined
            >
                <template v-slot:append>
                    <q-icon name="event" class="cursor-pointer">
                        <q-popup-proxy
                            ref="prefDate1Proxy"
                            cover
                            transition-show="scale"
                            transition-hide="scale"
                        >
                            <q-date
                                v-model="prefDate1"
                                @update:model-value="
                                    closeDatePicker('prefDate1Proxy')
                                "
                                :options="optionsFn"
                            >
                                <div class="row items-center justify-end">
                                    <q-btn
                                        v-close-popup
                                        label="Close"
                                        color="primary"
                                        flat
                                    />
                                    <q-btn
                                        v-close-popup
                                        label="Add"
                                        color="primary"
                                        flat
                                    />
                                </div>
                            </q-date>
                        </q-popup-proxy>
                    </q-icon>
                </template>
            </q-input>
        </div>

        <div class="col-4 q-px-xs">
            <q-input
                v-model="prefTime1"
                ref="prefTime1Ref"
                mask="time"
                :rules="[
                    'time',
                    (val) => (val && val.length > 0) || 'Please type something',
                ]"
                label="Time #1"
                outlined
            >
                <template v-slot:append>
                    <q-icon name="access_time" class="cursor-pointer">
                        <q-popup-proxy
                            ref="prefTime1Proxy"
                            cover
                            transition-show="scale"
                            transition-hide="scale"
                        >
                            <q-time
                                v-model="prefTime1"
                                @update:model-value="
                                    closeDatePicker('prefTime1Proxy')
                                "
                                mask="HH:mm"
                            >
                                <div class="row items-center justify-end">
                                    <q-btn
                                        v-close-popup
                                        label="Close"
                                        color="primary"
                                        flat
                                    />
                                    <q-btn
                                        v-close-popup
                                        label="Add"
                                        color="primary"
                                        flat
                                    />
                                </div>
                            </q-time>
                        </q-popup-proxy>
                    </q-icon>
                </template>
            </q-input>
        </div>

        <div class="col-8 q-px-xs">
            <q-input
                v-model="prefDate2"
                ref="prefDate2Ref"
                :rules="[
                    'date',
                    (val) => (val && val.length > 0) || 'Please type something',
                ]"
                mask="date"
                label="Preferred Date #2"
                outlined
            >
                <template v-slot:append>
                    <q-icon name="event" class="cursor-pointer">
                        <q-popup-proxy
                            ref="prefDate2Proxy"
                            cover
                            transition-show="scale"
                            transition-hide="scale"
                        >
                            <q-date
                                v-model="prefDate2"
                                @update:model-value="
                                    closeDatePicker('prefDate2Proxy')
                                "
                                :options="optionsFn"
                                mask="YYYY-MM-DD"
                            >
                                <div class="row items-center justify-end">
                                    <q-btn
                                        v-close-popup
                                        label="Close"
                                        color="primary"
                                        flat
                                    />
                                    <q-btn
                                        v-close-popup
                                        label="Add"
                                        color="primary"
                                        flat
                                    />
                                </div>
                            </q-date>
                        </q-popup-proxy>
                    </q-icon>
                </template>
            </q-input>
        </div>

        <div class="col-4 q-px-xs">
            <q-input
                v-model="prefTime2"
                ref="prefTime2Ref"
                mask="time"
                :rules="[
                    'time',
                    (val) => (val && val.length > 0) || 'Please type something',
                ]"
                label="TIme #2"
                outlined
            >
                <template v-slot:append>
                    <q-icon name="access_time" class="cursor-pointer">
                        <q-popup-proxy
                            ref="prefTime2Proxy"
                            cover
                            transition-show="scale"
                            transition-hide="scale"
                        >
                            <q-time
                                v-model="prefTime2"
                                @update:model-value="
                                    closeDatePicker('prefTime2Proxy')
                                "
                                mask="HH:mm"
                            >
                                <div class="row items-center justify-end">
                                    <q-btn
                                        v-close-popup
                                        label="Close"
                                        color="primary"
                                        flat
                                    />
                                    <q-btn
                                        v-close-popup
                                        label="Add"
                                        color="primary"
                                        flat
                                    />
                                </div>
                            </q-time>
                        </q-popup-proxy>
                    </q-icon>
                </template>
            </q-input>
        </div>

        <div class="col-8 q-px-xs">
            <q-input
                v-model="prefDate3"
                ref="prefDate3Ref"
                :rules="[
                    'date',
                    (val) => (val && val.length > 0) || 'Please type something',
                ]"
                mask="date"
                label="Preferred Date #3"
                outlined
            >
                <template v-slot:append>
                    <q-icon name="event" class="cursor-pointer">
                        <q-popup-proxy
                            ref="prefDate3Proxy"
                            cover
                            transition-show="scale"
                            transition-hide="scale"
                        >
                            <q-date
                                v-model="prefDate3"
                                @update:model-value="
                                    closeDatePicker('prefDate3Proxy')
                                "
                                :options="optionsFn"
                            >
                                <div class="row items-center justify-end">
                                    <q-btn
                                        v-close-popup
                                        label="Close"
                                        color="primary"
                                        flat
                                    />
                                    <q-btn
                                        v-close-popup
                                        label="Add"
                                        color="primary"
                                        flat
                                    />
                                </div>
                            </q-date>
                        </q-popup-proxy>
                    </q-icon>
                </template>
            </q-input>
        </div>

        <div class="col-4 q-px-xs">
            <q-input
                label="Time #3"
                v-model="prefTime3"
                ref="prefTime3Ref"
                mask="time"
                :rules="[
                    'time',
                    (val) => (val && val.length > 0) || 'Please type something',
                ]"
                outlined
            >
                <template v-slot:append>
                    <q-icon name="access_time" class="cursor-pointer">
                        <q-popup-proxy
                            ref="prefTime3Proxy"
                            cover
                            transition-show="scale"
                            transition-hide="scale"
                        >
                            <q-time
                                v-model="prefTime3"
                                @update:model-value="
                                    closeDatePicker('prefTime3Proxy')
                                "
                                mask="HH:mm"
                            >
                                <div class="row items-center justify-end">
                                    <q-btn
                                        v-close-popup
                                        label="Close"
                                        color="primary"
                                        flat
                                    />
                                    <q-btn
                                        v-close-popup
                                        label="Add"
                                        color="primary"
                                        flat
                                    />
                                </div>
                            </q-time>
                        </q-popup-proxy>
                    </q-icon>
                </template>
            </q-input>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <label>Comment, if any</label>
            <q-input
                v-model="comment"
                ref="commentRef"
                outlined
                type="textarea"
            />
        </div>
    </div>

    <div class="row q-mt-lg">
        <q-btn
            label="Request Appointment"
            color="indigo"
            size="lg"
            style="width: 100%"
            @click="requestAppointment"
        ></q-btn>
    </div>
</template>

<script>
import axios from "axios";
import { ref } from "vue";
import { BASE_PATH } from "@/main";
import { date, useQuasar } from "quasar";
import { TYPE_OF_APPOINTMENTS, PREFERRED_CLINIC } from "@/constants";
import { useRouter } from "vue-router";

export default {
    setup() {
        const typeOfAppointment = ref();
        const typeOfAppointmentOpts = ref(TYPE_OF_APPOINTMENTS);
        const prefferedClinic = ref();
        const prefferedClinicOpts = ref(PREFERRED_CLINIC);

        const prefDate1 = ref();
        const prefDate2 = ref();
        const prefDate3 = ref();
        const prefTime1 = ref();
        const prefTime2 = ref();
        const prefTime3 = ref();
        const comment = ref();

        const typeOfAppointmentRef = ref(null);
        const prefferedClinicRef = ref(null);
        const prefDate1Ref = ref(null);
        const prefDate2Ref = ref(null);
        const prefDate3Ref = ref(null);
        const prefTime1Ref = ref(null);
        const prefTime2Ref = ref(null);
        const prefTime3Ref = ref(null);
        const commentRef = ref(null);

        const closeDatePicker = (value) => {};
        const optionsFn = (_date) => {
            const dateValid = date.addToDate(new Date(), {
                days: 2,
            });
            return (
                _date >
                date.formatDate(
                    date.addToDate(new Date(), {
                        days: 1,
                    }),
                    "YYYY/MM/DD"
                )
            );
        };

        const $q = useQuasar();
        const router = useRouter();

        const requestAppointment = () => {
            typeOfAppointmentRef.value.validate();
            prefferedClinicRef.value.validate();
            prefDate1Ref.value.validate();
            prefDate2Ref.value.validate();
            prefDate3Ref.value.validate();
            prefTime1Ref.value.validate();
            prefTime2Ref.value.validate();
            prefTime3Ref.value.validate();
            commentRef.value.validate();

            if (
                typeOfAppointmentRef.value.hasError ||
                prefferedClinicRef.value.hasError ||
                prefDate1Ref.value.hasError ||
                prefDate2Ref.value.hasError ||
                prefDate3Ref.value.hasError ||
                prefTime1Ref.value.hasError ||
                prefTime2Ref.value.hasError ||
                prefTime3Ref.value.hasError ||
                commentRef.value.hasError
            ) {
                return;
            }

            const user = JSON.parse(localStorage.getItem("USER"));

            const payload = {
                id: user.Id,
                typeOfAppointment: typeOfAppointment.value,
                prefferedClinic: prefferedClinic.value,
                prefDate1: prefDate1.value,
                prefDate2: prefDate2.value,
                prefDate3: prefDate3.value,
                prefTime1: prefTime1.value,
                prefTime2: prefTime2.value,
                prefTime3: prefTime3.value,
                comment: comment.value,
                patientFirstName: user.FirstName,
                patientLastName: user.LastName,
                patientEmail: user.Email,
                patientMobile: user.mobileNumber,
            };

            axios.post(`${BASE_PATH}/request-appointment`, payload).then(() => {
                $q.notify({
                    message: "Request Appointment Successful",
                    icon: "info",
                    position: "top-right",
                    color: "positive",
                });

                router.push({ name: "Home" });
            });
        };

        return {
            typeOfAppointment,
            typeOfAppointmentOpts,
            prefferedClinic,
            prefferedClinicOpts,
            prefDate1,
            prefDate2,
            prefDate3,
            prefTime1,
            prefTime2,
            prefTime3,
            comment,
            typeOfAppointmentRef,
            prefferedClinicRef,
            prefDate1Ref,
            prefDate2Ref,
            prefDate3Ref,
            prefTime1Ref,
            prefTime2Ref,
            prefTime3Ref,
            commentRef,
            requestAppointment,
            closeDatePicker,
            optionsFn,
        };
    },
};
</script>
